import * as React from 'react';
import styled from 'react-emotion';
import { styles } from './styles';

export const RadioDot = styled<'input'>('input')<React.InputHTMLAttributes<{}>>(({ checked }) => {
  return styles.dot(checked || false);
});

interface Props {
  label?: JSX.Element;
}

export const RadioButton: React.SFC<Props & React.InputHTMLAttributes<{ value: string }>> = props => (
  <div className={styles.radioWrapper}>
    <RadioDot type={'radio'} {...props} checked={props.checked} />
    {props.label}
  </div>
);
